import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateFontDocument } from './update.generated';

export const useUpdateFont = (options: ApiOptions<typeof UpdateFontDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateFontDocument, {
    ...useNotifications(UpdateFontDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.fonts.update_success'),
    }),
    ...options,
  });
};
